var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgSlidersVertical = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/sliders-vertical",
    clipPath: "url(#clip0_8531_4625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.91634 14V9.33333M2.91634 6.66667V2M8.24967 14V8M8.24967 5.33333V2M13.583 14V10.6667M13.583 8V2M1.58301 9.33333H4.24967M6.91634 5.33333H9.58301M12.2497 10.6667H14.9163",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8531_4625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.25)"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSlidersVertical, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sliders-vertical.a48154b0.svg";
export { ForwardRef as ReactComponent };